import * as UI from "@iyk/ui"
import * as React from "react"

import { toSentenceCase } from "@iyk/string"
import { useExpand } from "../hooks/use-expand.ts"
import { useLang } from "../lang/use-lang.ts"
import { AnimateHeightChange } from "./animate-height-change.tsx"

export const CollapsibleSection = ({
  children,
  cutoff = 200,
}: {
  children: React.ReactNode
  cutoff?: number
}) => {
  const lang = useLang()
  const { ref, isExpanded, isAboveMinHeight, toggleExpanded } = useExpand({
    options: {
      minHeight: cutoff,
    },
  })

  const showGradient = !isExpanded && isAboveMinHeight
  const buttonText = isExpanded
    ? toSentenceCase(lang.terms.VIEW_LESS)
    : toSentenceCase(lang.terms.VIEW_MORE)

  const rootStyles = (cutoff: number) =>
    ({
      "--collapsible-cutoff": String(cutoff + "px"),
    }) as React.CSSProperties

  return (
    <AnimateHeightChange style={rootStyles(cutoff)}>
      <div ref={ref} className={classNameForItemDescription({ isExpanded })}>
        {children}
        {showGradient && (
          <div className="h-16 w-full absolute left-0 bottom-0 bg-gradient-to-t from-background to-50%" />
        )}
      </div>

      {isAboveMinHeight && (
        <button onClick={toggleExpanded} className="mt-2 mb-[5px] flex gap-1 items-center">
          <span className="text-xs-upper">{buttonText}</span>
          {isExpanded ? <UI.Icon.Minus /> : <UI.Icon.Plus />}
        </button>
      )}
    </AnimateHeightChange>
  )
}
const classNameForItemDescription = UI.cva(["relative overflow-hidden"], {
  variants: {
    isExpanded: {
      true: ["max-h-none"],
      false: ["max-h-[var(--collapsible-cutoff)]"],
    },
  },
})
